import { apiClient } from './authenticatedApiClient';

class AppDocumentenService {
  public downloadDocument(documentId: string): Promise<Blob> {
    return apiClient.get(`Documenten/${documentId}`, { responseType: 'blob' }).then(response => response.data);
  }
}

export const appDocumentenService = new AppDocumentenService();
